export default __webpack_public_path__ + "static/media/BBands.955c4234.md";